<template>
  <div class="dashboard-toggle">
    <label class="toggle-option" :class="{ active: currentView === 'v1' }">
      <input type="radio" name="dashboard-view" value="v1" v-model="currentView" @change="switchView" />
      <span class="toggle-label">Dust Kits</span>
    </label>
    <label class="toggle-option" :class="{ active: currentView === 'v2' }">
      <input type="radio" name="dashboard-view" value="v2" v-model="currentView" @change="switchView" />
      <span class="toggle-label">Air Kits</span>
    </label>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "DashboardToggle",
  data() {
    return {
      currentView: this.$store.getters.dashboardView || "v1"
    };
  },
  computed: {
    ...mapGetters(["dashboardView"])
  },
  methods: {
    ...mapActions(["switchDashboardView"]),
    switchView() {
      this.switchDashboardView(this.currentView);
      if (this.currentView === "v2") {
        this.$router.push("/home-v2");
      } else {
        this.$router.push("/home");
      }
    }
  },
  watch: {
    dashboardView(val) {
      this.currentView = val;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../styles/colors";

.dashboard-toggle {
  display: flex;
  justify-content: center;
  gap: 0;
  margin: 15px 0 0 0;
  font-family: TTNormsMedium, sans-serif;
}

.toggle-option {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 30px;
  cursor: pointer;
  background-color: $white;
  color: $gray;
  border: 2px solid #e0e0e0;
  transition: all 0.3s ease;
  font-size: 15px;
  user-select: none;

  &:first-child {
    border-radius: 25px 0 0 25px;
    border-right: 1px solid #e0e0e0;
  }

  &:last-child {
    border-radius: 0 25px 25px 0;
    border-left: 1px solid #e0e0e0;
  }

  &.active {
    background-color: $blue;
    color: $white;
    border-color: $blue;
  }

  input[type="radio"] {
    display: none;
  }

  .toggle-label {
    pointer-events: none;
  }
}
</style>
